import { Model } from "pinia-orm";
import Material from "@/models/Materials";
import AdditionalMaterial from "@/models/AdditionalMaterial";
import Analysis from "@/models/Analysis";

export default class Preparation extends Model {
  static entity = "preparations";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      mission: this.attr(null),
      materials: this.attr([]),
      materialsData: this.hasManyBy(Material, "materials"),
      validatedMaterials: this.attr([]),
      validatedMaterialsData: this.hasManyBy(Material, "validatedMaterials"),
      isValidated: this.boolean(false),
      additionalsMaterial: this.hasMany(AdditionalMaterial, "preparation"),
      analysis: this.attr([]),
      analysisData: this.hasManyBy(Analysis, "analysis"),
    };
  }
}
